import { trackingPageFlowStepArraySchema } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod";

export const updateTrackingPageFlow = {
  name: "updateTrackingPageFlow" as const,
  input: trackingPageFlowStepArraySchema,
  output: z.object({ success: z.boolean() }),
};
